import { Group, Table, UnstyledButton } from "@mantine/core";
import { IconChevronDown, IconChevronUp, IconSelector } from "@tabler/icons-react";
import type { ReactNode } from "react";
import type { SortDirection } from "./useTableSort";

interface SortableThProps {
  children: ReactNode;
  columnKey: string;
  sortKey: string | null;
  direction: SortDirection;
  onSort: (key: string) => void;
  miw?: string;
}

export function SortableTh({ children, columnKey, sortKey, direction, onSort, miw }: SortableThProps) {
  const active = sortKey === columnKey;
  const Icon = active ? (direction === "asc" ? IconChevronUp : IconChevronDown) : IconSelector;

  return (
    <Table.Th miw={miw}>
      <UnstyledButton
        type="button"
        className="axio-sortable-th"
        onClick={() => onSort(columnKey)}
        aria-sort={active ? (direction === "asc" ? "ascending" : "descending") : "none"}
      >
        <Group gap="var(--axio-unit-4)" wrap="nowrap" justify="flex-start">
          <span>{children}</span>
          <Icon size="var(--axio-unit-14)" stroke="var(--axio-stroke-width-regular)" className="axio-sortable-th-icon" data-active={active || undefined} />
        </Group>
      </UnstyledButton>
    </Table.Th>
  );
}
